import { Box, Button, DialogActions } from "@mui/material";
import { Work } from "../../../store/types/work.types";
import CloseWorkButton from "../CloseWorkButton";
import ReopenWorkButton from "../ReopenWorkButton";

interface WorkModalFooterProps {
  work: Work | undefined;
  showBackToActivity?: boolean;
  onBackToActivity?: () => void;
  onClose: () => void;
}

const WorkModalFooter = ({
  work,
  showBackToActivity,
  onBackToActivity,
  onClose,
}: WorkModalFooterProps) => {
  return (
    <DialogActions
      sx={{ p: 3, bgcolor: "grey.50", gap: 2, justifyContent: "space-between" }}
    >
      <Box sx={{ display: "flex", gap: 2 }}>
        {work && <CloseWorkButton work={work} />}
        {work && <ReopenWorkButton work={work} />}
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        {showBackToActivity && onBackToActivity && (
          <Button
            onClick={onBackToActivity}
            variant="outlined"
            size="large"
            sx={{ borderRadius: 2 }}
          >
            Tillbaka till aktivitet
          </Button>
        )}
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{ borderRadius: 2 }}
        >
          {showBackToActivity ? "Stäng allt" : "Stäng"}
        </Button>
      </Box>
    </DialogActions>
  );
};

export default WorkModalFooter;
